import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/rules/groups")({
  component: () => (
    <Breadcrumb label="Groups" to="/content/rules/groups">
      <Outlet />
    </Breadcrumb>
  ),
});
